<template>
  <div>
    <div class="content-bottom-padded">
      <el-alert type="info" title="操作说明" show-icon >
        <div> 企业ID:
          每个企业都拥有唯一的corpid，获取此信息可在管理后台“我的企业”－“企业信息”下查看“企业ID”（需要有管理员权限）<br>
          获取通讯录管理secret的方法如下：
          1、进入企业微信管理后台，在“管理工具” — “通讯录同步”开启“API接口同步”
          2、开启后，可设置通讯录API的权限：读取或者编辑通讯录
          3、使用通讯录同步的secret进行开发
          <br>
          联系人secret:管理员进入企业微信管理后台后点击“客户联系”-“客户”页面。点开“API”小按钮，可以看到secret，此为外部联系人secret。
        </div>
      </el-alert>
    </div>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-button-group>
          <el-button type="primary" icon="plus" @click="editConfig(null)" >添加企业微信</el-button>
        </el-button-group>
      </el-col>
    </el-row>
    <el-table :data="list" style="width: 100%" v-loading="loading" element-loading-text="数据加载中">
      <el-table-column prop="name" label="企业名称"> </el-table-column>
      <el-table-column prop="wx_corpid" label="企业ID"> </el-table-column>
      <el-table-column prop="create_time" label="绑定时间">
        <template slot-scope="scope">
          <span>{{scope.row.create_time | datetime('yyyy-MM-dd hh:mm:ss')}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="employee_secret" label="通讯录secret"> </el-table-column>
      <el-table-column prop="contact_secret" label="联系人管理secret"> </el-table-column>
      <el-table-column prop="encoding_aes_key" label="加密串"></el-table-column>
      <el-table-column prop="event_callback" label="回调地址"> </el-table-column>
      <el-table-column  label="操作：">
        <template slot-scope="scope">
          <!--<el-button type="text" @click="editConfig(scope.row)">编辑</el-button>-->
        </template>
      </el-table-column>
    </el-table>
    <!-- 添加 修改 -->
    <el-dialog :title="editTitle" :visible.sync="editVisible"  :before-close="handleEdit">
      <template>
        <el-form ref="form" :model="qyconfigForm" class="demo-ruleForm" label-width="120px">
          <el-form-item label="企业名称">
            <el-input v-model="qyconfigForm.name" placeholder="企业名称"></el-input>
          </el-form-item>
          <el-form-item label="企业ID">
            <el-input v-model="qyconfigForm.corpid" placeholder="企业ID"></el-input>
          </el-form-item>
          <el-form-item label="通讯录secret">
            <el-input v-model="qyconfigForm.employee_secret" placeholder="联系人管理secret"></el-input>
          </el-form-item>
          <el-form-item label="联系人secret">
            <el-input v-model="qyconfigForm.contact_secret" placeholder="联系人管理secret"></el-input>
          </el-form-item>
          <el-form-item label="加密串">
            <el-input v-model="qyconfigForm.encoding_aes_key" placeholder="加密串"></el-input>
          </el-form-item>
          <el-form-item label="回调地址">
            <el-input v-model="qyconfigForm.event_callback" placeholder="回调地址"></el-input>
          </el-form-item>
        </el-form>
      </template>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editCategroyVisible = false">取消</el-button>
        <el-button type="primary" @click="submitAction" :loading="submitLoading">{{submitLoading ? '提交中' : '保存'}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import { getWorkList,addWorkConfig} from '../../../api/workwx'
  export default {
    data () {
      return {
        loading: false,
        editVisible:false,
        submitLoading:false,
        editTitle: '',
        eidttype:'',
        qyconfigForm: {
          name: '',
          corpid: '',
          employee_secret: '',
          contact_secret: '',
          encoding_aes_key: '',
          event_callback: ''
        },
        templateList: [],
        list: []
      }
    },
    methods: {
      getWorkList () {
        this.loading = true
        getWorkList().then(response => {
          this.list = response.data.data.list
          this.loading = false
        })
      },
      editConfig(row){
        this.editVisible = true
        if(row){
          this.editTitle = "编辑企业微信"
          this.qyconfigForm.name = row.name
          this.qyconfigForm.corpid = row.wx_corpid
          this.qyconfigForm.employee_secret = row.employee_secret
          this.qyconfigForm.encoding_aes_key = row.encoding_aes_key
          this.qyconfigForm.event_callback = row.event_callback
          this.qyconfigForm.contact_secret = row.contact_secret
          this.qyconfigForm.id = row.id

        }else{
          this.configFormempty()
          this.editTitle = "添加企业微信"
          this.eidttype = 'add'
        }

      },
      configFormempty(){
        this.qyconfigForm.name = ''
        this.qyconfigForm.corpid = ''
        this.qyconfigForm.employee_secret = ''
        this.qyconfigForm.encoding_aes_key = ''
        this.qyconfigForm.event_callback = ''
        this.qyconfigForm.contact_secret = ''
        this.qyconfigForm.id = ''
      },
      submitAction(){
        this.submitLoading = true
        if(this.eidttype=='add'){
          addWorkConfig(this.qyconfigForm).then(res=>{
            if (res.data.data.status) {
              this.$message({
                type: 'success',
                message: '添加成功'
              })
            }
          })
        }
      },
      handleEdit(){
        this.editVisible = false
        this.editTitle = ""
      }
    },
    mounted () {
      this.getWorkList()
    }
  }
</script>
<style scoped lang="scss">
  .el-row {
    margin-bottom: 10px;
    .frm-tips {
      color: #8d8d8d;
    }
  }
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
  .wxa-select {
    padding: 0 25px 25px;
  }
  .webchat-box {
    padding: 10px 0;
  }
</style>



// WEBPACK FOOTER //
// index.vue?fcf8f84c